export default {
    'halls.loading': 'กำลังโหลด',
    'halls.primary.title': 'การฝึกฝน',
    'halls.middle.title': 'ผู้เชี่ยวชาญ',
    'halls.high.title': 'เอลีต',
    'halls.top.title': 'นายมือ',
    'halls.level.describe': 'เงื่อนไขของห้อง',
    'halls.coin.not': 'เหรียญไม่เพียงพอ',
    'halls.setting.title': 'การตั้งค่า',
};